import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "احسب نسبة 5% من مبلغ - حاسبة 5 بالمئة الالكترونية - تعلم كم تساوي خمسة في المئة";
const DESCRIPTION =
  "تعلم كيف تقوم ب احسب نسبة 5% من مبلغ - حاسبة 5 بالمئة - حساب كم تساوي خمسة بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 5 بالمئة من مبلغ او قيمة معينة";
const KEYWORDS =
  "احسب نسبة 5% من مبلغ - حاسبة 5 بالمئة - حساب كم تساوي خمسة بالمئة, 5%, حساب النسبة المئوية";
const OG_URL = "https://do-calculate.com/calculator/ar/5percent/";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  لحساب نسبة 5% من قيمة معينة، يمكنك اتباع الخطوات التالية:
                </h2>
                <ul>
                  <li>
                    قم بضرب القيمة بنسبة 5% ككسر. يمكن تمثيل 5% على شكل كسر على
                    النحو التالي: 5/100.
                  </li>
                  <li>
                    بعد ذلك، قم بضرب القيمة الأصلية في النسبة المكونة من الكسر.
                    لنفترض أن لديك قيمة معينة تريد حساب 5% منها، فلنقل أن هذه
                    القيمة تساوي 100، يمكنك استخدام المعادلة التالية:
                    <br />
                    النسبة = (القيمة الأصلية × الكسر 5/100)
                  </li>
                  <li>
                    أو يمكنك ببساطة إجراء العملية الحسابية كالتالي: قسم القيمة
                    الأصلية على 20.
                    <br />
                    النسبة = القيمة الأصلية / 20
                  </li>
                  <li>ستحصل على النسبة المطلوبة، وهي 5% من القيمة الأصلية.</li>
                </ul>
                <ul>
                  تقوم هذه الحاسبة ايضا بحساب :<li> نسبة 1 بالمئة </li>
                  <li> نسبة 2 بالمئة</li>
                  <li> نسبة 3 بالمئة</li>
                  <li> نسبة 4 بالمئة</li>
                  <li> نسبة 5 بالمئة </li>
                  <li> نسبة 6 بالمئة </li>
                  <li> نسبة 7 بالمئة</li>
                  <li> نسبة 8 بالمئة </li>
                  <li> نسبة 9 بالمئة </li>
                </ul>
                <b>
                  يمكنك أيضا استخدام الحاسبة الالكترونية التالية لحساب نسبة 5
                  بالمئة من رقم او مبلغ معين:
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={5} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
